import { createApiHandler } from './handler';

const orders = {
  apiClient: null,
  path: '/admin/orders',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async pickup(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/pickup`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async send(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/send`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async separate(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/separate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async changeToReadyForPickupStatus(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/change-to-ready-for-pickup-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async changeToReadyForDeliveryStatus(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/change-to-ready-for-delivery-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async changeStatus(id, data) {
    try {
      const response = await this.apiClient.patch(`${this.path}/${id}/change-status`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async searchOrderCycles(search) {
    try {
      const response = await this.apiClient.get(`${this.path}/order-cycles/search`, { params: { search } });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Genera N órdenes manualmente para un order cycle.
   *
   * @param {number} orderCycleId
   * @param {number} count   — cantidad de órdenes a generar (1-12)
   * @param {boolean} deductBudget — si true (default), deduce del saldo del cliente.
   *   Usa false SOLO para cortesías o reemplazos de órdenes ya cobradas.
   */
  async generateOrders(orderCycleId, count, deductBudget = true) {
    try {
      const response = await this.apiClient.post(
        `${this.path}/order-cycles/${orderCycleId}/generate`,
        { count, deduct_budget: deductBudget }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default orders;
